export const limitNumberWithinRange = (num: number, min: number, max: number) => {
    return num === 0 ? min : Math.min(Math.max(num, min), max);
};
